import axios from 'axios';
import Swal from 'sweetalert2';
import Cookies from 'js-cookie';
import { useNavigate } from 'react-router-dom';
import React, { useEffect, useState } from 'react';
// api
import ApiKey from '../../api/ApiKey';
import BaseApi from '../../api/BaseApi';
// components
import APNavBar from '../Elements/APNavBar';
import APSidebar from '../APSidebar/APSidebar';
// mui
import Link from '@mui/material/Link';
import Stack from '@mui/material/Stack';
import Tooltip from '@mui/material/Tooltip';
import AddIcon from '@mui/icons-material/Add';
import BlockIcon from '@mui/icons-material/Block';
import CheckIcon from '@mui/icons-material/Check';
import Pagination from '@mui/material/Pagination';
import Typography from '@mui/material/Typography';
import Breadcrumbs from '@mui/material/Breadcrumbs';
import CreateIcon from '@mui/icons-material/Create';
import DeleteIcon from '@mui/icons-material/Delete';
import NavigateNextIcon from '@mui/icons-material/NavigateNext';

const APCategoryList = () => {
  const navigate = useNavigate();
  const tokenKey = Cookies.get('token');
  const adminID = Cookies.get('adminID');

  const [listData, setListData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [selectAll, setSelectAll] = useState(true);
  const [currentPage, setCurrentPage] = useState(1);
  const [checkedData, setCheckedData] = useState([]);
  const [searchQuery, setSearchQuery] = useState('');
  const [smallLoading, setSmallLoading] = useState(false);

  const itemsPerPage = 20;

  const getData = async () => {
    try {
      setLoading(true);

      const response = await axios.post(
        BaseApi + '/admin/category/index',
        null,
        {
          headers: {
            key: ApiKey,
            adminid: adminID,
            ContentType: 'application/json',
            Authorization: `Bearer ${tokenKey}`,
          },
        },
      );

      setLoading(false);
      setListData(response.data.response);
    } catch (error) {
      setLoading(false);
      console.error('Cannot get Categories List', error);
    }
  };

  const handleActivate = async id => {
    try {
      const confirmationResult = await Swal.fire({
        icon: 'question',
        cancelButtonText: 'No',
        showCancelButton: true,
        confirmButtonText: 'Yes',
        title: 'Activate Category?',
        text: 'Do you want to Activate this category?',
      });
      if (confirmationResult.isConfirmed) {
        const response = await axios.post(
          BaseApi + `/admin/category/admin_activate/${id}`,
          null,
          {
            headers: {
              key: ApiKey,
              adminid: adminID,
              ContentType: 'application/json',
              Authorization: `Bearer ${tokenKey}`,
            },
          },
        );

        if (response.data.status === 200) {
          Swal.fire({
            icon: 'success',
            confirmButtonText: 'Close',
            title: 'Category Activated successfully!',
          });
        } else {
          Swal.fire({
            icon: 'error',
            confirmButtonText: 'Close',
            title: response.data.message,
          });
        }

        getData();
      }
    } catch (error) {
      Swal.fire({
        icon: 'error',
        confirmButtonText: 'Close',
        text: 'Could not Activate Category',
        title: 'Failed. Please try after some time!',
      });

      console.error('Couldn\'t activate the record!', error.message);
    }
  };

  const handleDeactivate = async id => {
    try {
      const confirmationResult = await Swal.fire({
        icon: 'question',
        cancelButtonText: 'No',
        showCancelButton: true,
        confirmButtonText: 'Yes',
        title: 'Deactivate Category?',
        text: 'Do you want to Deactivate this Category?',
      });

      if (confirmationResult.isConfirmed) {
        const response = await axios.post(
          BaseApi + `/admin/category/admin_deactivate/${id}`,
          null,
          {
            headers: {
              key: ApiKey,
              adminid: adminID,
              ContentType: 'application/json',
              Authorization: `Bearer ${tokenKey}`,
            },
          },
        );

        if (response.data.status === 200) {
          Swal.fire({
            icon: 'success',
            confirmButtonText: 'Close',
            title: 'Category Deactivated successfully!',
          });
        } else {
          Swal.fire({
            icon: 'error',
            confirmButtonText: 'Close',
            title: response.data.message,
          });
        }

        getData();
      }
    } catch (error) {
      Swal.fire({
        icon: 'error',
        confirmButtonText: 'Close',
        text: 'Could not Deactivate Category',
        title: 'Failed. Please try after some time!',
      });

      console.error('Couldn\'t deactivate the record!', error.message);
    }
  };

  const handleDelete = async id => {
    try {
      const confirmationResult = await Swal.fire({
        icon: 'question',
        cancelButtonText: 'No',
        showCancelButton: true,
        confirmButtonText: 'Yes',
        title: 'Delete Category?',
        text: 'Do you want to Delete this Category?',
      });

      if (confirmationResult.isConfirmed) {
        const response = await axios.post(
          BaseApi + `/admin/category/admin_delete/${id}`,
          null,
          {
            headers: {
              key: ApiKey,
              adminid: adminID,
              ContentType: 'application/json',
              Authorization: `Bearer ${tokenKey}`,
            },
          },
        );

        if (response.data.status === 200) {
          Swal.fire({
            icon: 'success',
            confirmButtonText: 'Close',
            title: 'Category deleted successfully!',
          });
        } else {
          Swal.fire({
            icon: 'error',
            confirmButtonText: 'Close',
            title: response.data.message,
          });
        }

        getData();
      }
    } catch (error) {
      Swal.fire({
        icon: 'error',
        confirmButtonText: 'Close',
        text: 'Could not Delete Category',
        title: 'Failed. Please try after some time!',
      });

      console.error('Couldn\'t delete the record!', error.message);
    }
  };

  const handleCheck = id => {
    if (id === 'selectAll') {
      setSelectAll(!selectAll);

      const updatedCheckedData = selectAll
        ? listData.map(item => item.id)
        : [];
      setCheckedData(updatedCheckedData);
    } else {
      if (checkedData.includes(id)) {
        setCheckedData(checkedData.filter(checkedId => checkedId !== id));
      } else {
        setCheckedData([...checkedData, id]);
      }
    }
  };

  const handleMultipleDeactivate = async () => {
    try {
      const confirmationResult = await Swal.fire({
        icon: 'question',
        cancelButtonText: 'No',
        showCancelButton: true,
        confirmButtonText: 'Yes',
        title: 'Deactivate Category?',
        text: 'Do you want to Deactivate these Category?',
      });
      if (confirmationResult.isConfirmed) {
        const ids = checkedData.join(',');

        const response = await axios.post(
          BaseApi + '/admin/category/index',
          {
            idList: ids,
            action: 'deactivate',
          },
          {
            headers: {
              key: ApiKey,
              adminid: adminID,
              ContentType: 'application/json',
              Authorization: `Bearer ${tokenKey}`,
            },
          },
        );

        setSelectAll(true);
        setCheckedData('');

        if (response.data.status === 200) {
          Swal.fire({
            icon: 'success',
            confirmButtonText: 'Close',
            title: 'Category Deactivated successfully!',
          });
        } else {
          Swal.fire({
            icon: 'error',
            confirmButtonText: 'Close',
            title: 'Couldn\'t Deactivate!',
          });
        }

        getData();
      }
    } catch (error) {
      Swal.fire({
        icon: 'error',
        confirmButtonText: 'Close',
        text: 'Could not Deactivate Category',
        title: 'Failed. Please try after some time!',
      });

      console.error('Couldn\'t deactivate the record!', error.message);
    }
  };

  const handleMultipleActivate = async () => {
    try {
      const confirmationResult = await Swal.fire({
        icon: 'question',
        cancelButtonText: 'No',
        showCancelButton: true,
        confirmButtonText: 'Yes',
        title: 'Activate Category?',
        text: 'Do you want to Activate these Category?',
      });

      if (confirmationResult.isConfirmed) {
        const ids = checkedData.toString();

        const response = await axios.post(
          BaseApi + '/admin/category/index',
          {
            idList: ids,
            action: 'activate',
          },
          {
            headers: {
              key: ApiKey,
              adminid: adminID,
              ContentType: 'application/json',
              Authorization: `Bearer ${tokenKey}`,
            },
          },
        );

        setSelectAll(true);
        setCheckedData('');

        if (response.data.status === 200) {
          Swal.fire({
            icon: 'success',
            confirmButtonText: 'Close',
            title: 'Category Activated successfully!',
          });
        } else {
          Swal.fire({
            icon: 'error',
            confirmButtonText: 'Close',
            title: 'Couldn\'t Activate!',
          });
        }

        getData();
      }
    } catch (error) {
      Swal.fire({
        icon: 'error',
        confirmButtonText: 'Close',
        text: 'Could not Activate Category',
        title: 'Failed. Please try after some time!',
      });

      console.error('Couldn\'t activate the record!', error.message);
    }
  };

  const sortAndFilterData = (array, key, direction, query) => {
    const sortedAndFilteredArray = [...array]
      .filter(
        item =>
          item.name?.toLowerCase().includes(query) ||
          item.created?.toLowerCase().includes(query),
      )
      .sort((a, b) => {
        if (a[key] < b[key]) {
          return direction === 'ascending' ? -1 : 1;
        }
        if (a[key] > b[key]) {
          return direction === 'ascending' ? 1 : -1;
        }
        return 0;
      });
    return sortedAndFilteredArray;
  };
  const [sortConfig, setSortConfig] = useState({
    key: '',
    direction: 'ascending',
  });
  const [symbol, setSymbol] = useState('🔺');

  const sortedAndFilteredData = sortAndFilterData(
    listData,
    sortConfig.key,
    sortConfig.direction,
    searchQuery,
  );

  const filteredData = listData.filter(item => {
    const searchString = searchQuery.toLowerCase();
    return (
      item.name?.toLowerCase().includes(searchString) ||
      item.created?.toLowerCase().includes(searchString)
    );
  });

  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = sortedAndFilteredData.slice(
    indexOfFirstItem,
    indexOfLastItem,
  );

  const totalPages = Math.ceil(sortedAndFilteredData.length / itemsPerPage);

  const pageNumbers = [];
  for (let i = 1; i <= totalPages; i++) {
    pageNumbers.push(i);
  }

  const handleColumnClick = key => {
    let direction = 'ascending';
    if (sortConfig.key === key && sortConfig.direction === 'ascending') {
      direction = 'descending';
      setSymbol('🔻');
    } else {
      setSymbol('🔺');
    }
    setSortConfig({ key, direction });
  };

  const handleSearchChange = e => {
    const newQuery = e.target.value.toLowerCase();

    setSearchQuery(newQuery);
  };

  const getCurrentDateFormatted = () => {
    const date = new Date();
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const year = date.getFullYear();

    return `${day}.${month}.${year}`;
  };

  const handleDownloadList = async () => {
    try {
      setSmallLoading(true);

      await fetch(
        BaseApi + '/admin/category/generate_csv',
        {
          method: 'GET',
          headers: {
            key: ApiKey,
            adminid: adminID,
            Authorization: `Bearer ${tokenKey}`,
          },
        },
      )
        .then(response => {
          if ((response.ok === true) & (response.status === 200)) {
            return response.blob();
          }
        })
        .then(data => {
          const url = window.URL.createObjectURL(data);
          const link = document.createElement('a');
          link.href = url;

          const fileName = `all_categories_and_subcategories_${getCurrentDateFormatted()}.xlsx`;

          link.setAttribute('download', fileName);
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
        });

      setSmallLoading(false);
    } catch (error) {
      setSmallLoading(false);

      console.error('Error downloading the file:', error);
    }
  };

  useEffect(() => {
    if (!tokenKey) {
      navigate('/admin');
    } else {
      getData();

      window.scrollTo(0, 0);
    }
  }, [tokenKey, navigate]); // eslint-disable-line

  useEffect(() => {
    setCurrentPage(1);
  }, [searchQuery]);

  return (
    <>
      <APNavBar />
      <div className='APBasic APManageSubadmin'>
        <APSidebar />

        {
          loading
            ? (
              <div className='loader-container' />
            ) : (
              <div className='site-min-height'>
                <div className='breadCumb1' role='presentation'>
                  <Breadcrumbs
                    aria-label='breadcrumb'
                    separator={<NavigateNextIcon fontSize='small' />}
                  >
                    <Link
                      underline='hover'
                      color='inherit'
                      onClick={() => navigate('/admin/admins/dashboard')}
                    >
                      Dashboard
                    </Link>
                    <Link
                      underline='hover'
                      color='inherit'
                      onClick={() => navigate('')}
                    >
                      Categories
                    </Link>
                    <Typography color='text.primary'>Categories List</Typography>
                  </Breadcrumbs>
                </div>
                <div className='ManageSubAdminHeader d-flex justify-content-between align-items-center flex-wrap'>
                  <h2 className=''>Category List</h2>
                  <div>
                    <button
                      className='btn navButton1 APMSbutton'
                      onClick={() => navigate('/admin/categories/addcategory')}
                    >
                      Add Category
                    </button>
                    <button
                      disabled={smallLoading}
                      onClick={() => handleDownloadList()}
                      className='btn navButton1 APMSbutton'
                    >
                      Download List
                    </button>
                  </div>
                </div>
                {
                  listData != ''
                    ? (
                      <>
                        <div className='manageSubadminPart1'>
                          <form>
                            <div className='manageSubadminPart1Sec1'>
                              <h4>Search Category by Name</h4>
                              <div className='APDashboardSearchBx '>
                                <input
                                  type='text'
                                  id='searchQuery'
                                  name='searchQuery'
                                  value={searchQuery}
                                  placeholder='Search..'
                                  className='form-control'
                                  onChange={handleSearchChange}
                                />
                              </div>
                            </div>
                          </form>
                          <h4>
                            No. of Results {indexOfFirstItem + 1}-
                            {Math.min(
                              indexOfLastItem,
                              filteredData.length || listData.length,
                            )}{' '}
                            of {listData.length}
                          </h4>
                        </div>
                        <div className='manageSubadminPart2'>
                          <table className='table'>
                            <thead>
                              <tr>
                                <td className='checkBoxCol checkBxHead'>
                                  <input
                                    type='checkbox'
                                    className='tableCheckBox'
                                    onClick={() => handleCheck('selectAll')}
                                  />
                                </td>
                                <th onClick={() => handleColumnClick('name')}>
                                  Category Name {symbol}
                                </th>
                                <th onClick={() => handleColumnClick('created')}>
                                  Created {symbol}
                                </th>
                                <th scope='col'>Action</th>
                              </tr>
                            </thead>
                            <tbody>
                              {
                                currentItems.map(i => (
                                  <>
                                    <tr>
                                      <td className='checkBoxCol'>
                                        <input
                                          type='checkbox'
                                          className='tableCheckBox'
                                          onChange={() => handleCheck(i.id)}
                                          checked={checkedData.includes(i.id)}
                                        />
                                      </td>
                                      <td>{i.name}</td>
                                      <td>{i.created}</td>
                                      <td className='APActionButton'>
                                        {
                                          i.status === 1
                                            ? (
                                              <button
                                                className='btn-secondary activated'
                                                onClick={() => handleDeactivate(i.id)}
                                              >
                                                <Tooltip title='Deactivate'>
                                                  <CheckIcon />
                                                </Tooltip>
                                              </button>
                                            ) : (
                                              <button
                                                className='btn-secondary'
                                                onClick={() => handleActivate(i.id)}
                                              >
                                                <Tooltip title='Activate'>
                                                  <BlockIcon />
                                                </Tooltip>
                                              </button>
                                            )
                                        }
                                        <button
                                          className='btn-primary'
                                          onClick={() => navigate(`/admin/categories/editcategory/${i.id}`)}
                                        >
                                          <Tooltip title='Edit'>
                                            <CreateIcon />
                                          </Tooltip>
                                        </button>
                                        <button
                                          className='btn btn-secondary'
                                          onClick={() => handleDelete(i.id)}
                                        >
                                          <Tooltip title='Delete'>
                                            <DeleteIcon />
                                          </Tooltip>
                                        </button>
                                        <button
                                          className='btn-primary'
                                          onClick={() => navigate(`/admin/categories/subindex/${i.id}`)}
                                        >
                                          <Tooltip title='Sub Category List'>
                                            <AddIcon />
                                          </Tooltip>
                                        </button>
                                      </td>
                                    </tr>
                                  </>
                                ))
                              }
                            </tbody>
                          </table>
                        </div>
                        <div className='manageSubadminpart3'>
                          <div className='functionalityButton'>
                            <button
                              type='button'
                              className='btn btn-primary APButton3'
                              onClick={() => handleMultipleActivate()}
                            >
                              ACTIVATE
                            </button>
                            <button
                              type='button'
                              className='btn btn-primary APButton3'
                              onClick={() => handleMultipleDeactivate()}
                            >
                              DEACTIVATE
                            </button>
                          </div>
                          <div className='mb-4 pagination'>
                            <Stack spacing={2}>
                              <Pagination
                                color='primary'
                                count={totalPages}
                                page={currentPage}
                                onChange={(event, page) => setCurrentPage(page)}
                              />
                            </Stack>
                          </div>
                        </div>
                      </>
                    ) : (
                      <div className='appliedJobListNoData mt-5'>
                        No Records Found
                      </div>
                    )
                }
              </div>
            )
        }
      </div>
    </>
  );
};

export default APCategoryList;
